<template>
  <div class="filters print-hidden" v-intro="$t('surveyFilter.introjsMenu')" v-intro-step="6">
    <div class="filters-head">
      <span>
        {{ $t('surveyFilter.filterBy') }}
        <span class="filter-name">
          {{ getDisplayByCode(selectedCode) }}
          <template v-if="selectedCategory">
            : {{ getCategoryDisplay(selectedCode, selectedCategory) }}
          </template>
        </span>
      </span>
      <div class="clearFilter" @click="clearFilter()" v-if="selectedCode">{{ $t('surveyFilter.clearFilter') }}</div>
    </div>
    <ul class="filters-container">
      <li
        v-for="(filter, index) of filters"
        :key="filter.code"
        class="filter link-dropdown-menu"
        @mouseover="open(index)"
        @mouseleave="clear()"
        @click="open(index, true)"
        :class="{ active: isOpened(index), selected: isSelectedCode(filter.code) }">
        <span>
          {{ filter.display }}
          <i class="fa" :class="{ 'fa-chevron-up': !isOpened(index), 'fa-chevron-down': isOpened(index)}" ></i>
        </span>
        <div class="filter-choices">
          <div class="filter-choices-item">
            <ul>
              <li
                v-for="choice of filter.choices"
                :key="choice.category"
                @click="selectFilter(filter.code, choice.category)"
                :class="{ emphasis: isEmphased(filter.code, choice.category) }">
                {{ choice.display }}
              </li>
            </ul>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'surveyFilters',
  components: {
  },
  data() {
    return {
      openedFilter: undefined,
      filters: [
        {
          display: this.$t('surveyFilter.S.label'),
          code: 'S',
          choices: [
            { display: this.$t('surveyFilter.S.C01'), category: 'C01' },
            { display: this.$t('surveyFilter.S.C02'), category: 'C02' },
            { display: this.$t('surveyFilter.S.C03'), category: 'C03' },
            { display: this.$t('surveyFilter.S.C04'), category: 'C04' },
            { display: this.$t('surveyFilter.S.C05'), category: 'C05' },
            { display: this.$t('surveyFilter.S.C06'), category: 'C06' },
            { display: this.$t('surveyFilter.S.C07'), category: 'C07' },
            { display: this.$t('surveyFilter.S.C08'), category: 'C08' },
            { display: this.$t('surveyFilter.S.C09'), category: 'C09' },
            { display: this.$t('surveyFilter.S.C10'), category: 'C10' },
            { display: this.$t('surveyFilter.S.C11'), category: 'C11' },
            { display: this.$t('surveyFilter.S.C12'), category: 'C12' },
            { display: this.$t('surveyFilter.S.C13'), category: 'C13' },
            { display: this.$t('surveyFilter.S.C16'), category: 'C16' },
            { display: this.$t('surveyFilter.S.S14'), category: 'S14' },
            { display: this.$t('surveyFilter.S.C18'), category: 'C18' },
          ],
        },
        {
          display: this.$t('surveyFilter.T.label'),
          code: 'T',
          choices: [
            { display: this.$t('surveyFilter.T.P1'), category: 'P1' },
            { display: this.$t('surveyFilter.T.P2_4'), category: 'P2-4' },
            { display: this.$t('surveyFilter.T.P5_9'), category: 'P5-9' },
            { display: this.$t('surveyFilter.T.P10_19'), category: 'P10-19' },
            { display: this.$t('surveyFilter.T.P20_49'), category: 'P20-49' },
            { display: this.$t('surveyFilter.T.P50_99'), category: 'P50-99' },
            { display: this.$t('surveyFilter.T.P100'), category: 'P100+' },

          ],
        },
        {
          display: this.$t('surveyFilter.P.label'),
          code: 'P',
          choices: [
            { display: this.$t('surveyFilter.P.BW'), category: 'BW' },
            { display: this.$t('surveyFilter.P.HAI'), category: 'HAI' },
            { display: this.$t('surveyFilter.P.LG'), category: 'LG' },
            { display: this.$t('surveyFilter.P.LUX'), category: 'LUX' },
            { display: this.$t('surveyFilter.P.NAM'), category: 'NAM' },


          ],
        },
        {
          display: this.$t('surveyFilter.M.label'),
          code: 'M',
          choices: [
            { display: this.$t('surveyFilter.M.UNIQUE'), category: 'UNIQUE' },
            { display: this.$t('surveyFilter.M.MULTI'), category: 'MULTI' },
          ],
        },
        // {
        //   display: this.$t('surveyFilter.Z.label'),
        //   code: 'Z',
        //   choices: [
        //     { display: this.$t('surveyFilter.Z.DANSZAE'), category: 'DANSZAE' },
        //     { display: this.$t('surveyFilter.Z.HORSZAE'), category: 'HORSZAE' },
        //   ],
        // },
        {
          display: this.$t('surveyFilter.A.label'),
          code: 'A',
          choices: [
            { display: this.$t('surveyFilter.A.B2C'), category: 'B2C' },
            { display: this.$t('surveyFilter.A.B2B'), category: 'B2B' },
            { display: this.$t('surveyFilter.A.NM'), category: 'NM' },
            { display: this.$t('surveyFilter.A.ADM'), category: 'ADM' },
          ],
        },
        {
          display: this.$t('surveyFilter.E.label'),
          code: 'E',
          choices: [
            { display: this.$t('surveyFilter.E.EXPORT'), category: 'EXPORT' },
            { display: this.$t('surveyFilter.E.NONEXP'), category: 'NONEXP' },
          ],
        },
        {
          display: this.$t('surveyFilter.ECO.label'),
          code: 'ECO',
          choices: [
            { display: this.$t('surveyFilter.ECO.CLASSIQUE'), category: 'CLASSIQUE' },
            { display: this.$t('surveyFilter.ECO.EES'), category: 'EES' },
          ],
        },
      ],
    };
  },
  props: {
    selectedCode: String,
    selectedCategory: String,
    mySectorCode: String,
    myProvince: String,
    myEnterpriseSize: Number,
    myTargetMarket: Number,
    myExportation: Number,
    mySite: Number,
  },
  methods: {
    clear() {
      this.openedFilter = undefined;
    },
    open(index, toggle = false) {
      if (index === this.openedFilter && toggle) {
        this.clear();
      } else {
        this.openedFilter = index;
      }
    },
    isOpened(index) {
      return index === this.openedFilter;
    },
    isSelectedCode(code) {
      return code === this.selectedCode;
    },
    isSelectedCategory(category) {
      return category === this.selectedCategory;
    },
    getDisplayByCode(code) {
      const filter = this.filters.find((f) => f.code === code);
      return (filter) ? filter.display : '';
    },
    getCategoryDisplay(code, category) {
      const filter = this.filters.find((f) => f.code === code);
      if (filter) {
        const choice = filter.choices.find((c) => c.category === category);
        return (choice) ? choice.display : '';
      }
      return '';
    },
    isEmphased(code, category) {
      let provinceCode = '';
      let enterpriseSize = '';
      let enterpriseExportation = '';
      let enterpriseSites = '';
      switch (code) {
        case 'S':
          return this.mySectorCode === category;
        case 'P':
          switch (this.myProvince) {
            case 'Brabant Wallon':
              provinceCode = 'BW';
              break;
            case 'Hainaut':
              provinceCode = 'HAI';
              break;
            case 'Liège':
              provinceCode = 'LG';
              break;
            case 'Luxembourg':
              provinceCode = 'LUX';
              break;
            case 'Namur':
              provinceCode = 'NAM';
              break;
            default:
              break;
          }
          return provinceCode === category;
        case 'T':
          switch (this.myEnterpriseSize) {
            case 1:
              enterpriseSize = 'P1';
              break;
            case 2:
              enterpriseSize = 'P2-4';
              break;
            case 3:
              enterpriseSize = 'P5-9';
              break;
            case 4:
              enterpriseSize = 'P10-19';
              break;
            case 5:
              enterpriseSize = 'P20-49';
              break;
            case 6:
              enterpriseSize = 'P50-99';
              break;
            case 7:
              enterpriseSize = 'P100+';
              break;
            default:
              break;
          }
          return enterpriseSize === category;
        case 'A':
          if (this.myTargetMarket <= 0) {
            return false;
          }
          /* eslint no-bitwise: ["error", { "allow": ["&"] }] */
          switch (category) {
            case 'ADM':
              return this.myTargetMarket & 8;
            case 'NM':
              return this.myTargetMarket & 4;
            case 'B2B':
              return this.myTargetMarket & 2;
            case 'B2C':
              return this.myTargetMarket & 1;
            default:
              break;
          }
          break;
        case 'M':
          switch (this.mySite) {
            case 1:
              enterpriseSites = 'UNIQUE';
              break;
            case 2:
              enterpriseSites = 'MULTI';
              break;
            default:
              break;
          }
          return enterpriseSites === category;
        case 'E':
          switch (this.myExportation) {
            case 1:
              enterpriseExportation = 'EXPORT';
              break;
            case 2:
              enterpriseExportation = 'NONEXP';
              break;
            default:
              break;
          }
          return enterpriseExportation === category;
        default:
          break;
      }
      return false;
    },
    selectFilter(code, category) {
      this.$emit('selectfilter', code, category);
    },
    clearFilter() {
      this.$emit('clearfilter');
    },
  },
};
</script>
